var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneLinear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-1h24v24H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.475.984L16.428.05a1.96 1.96 0 00-2.248 1.143l-1.868 4.362c-.344.8-.112 1.745.562 2.295l1.719 1.406a13.363 13.363 0 01-5.336 5.334l-1.405-1.72a1.97 1.97 0 00-2.295-.563l-4.365 1.87A1.966 1.966 0 00.05 16.426l.933 4.048A1.959 1.959 0 002.898 22C13.42 22.004 22 13.482 22 2.9c0-.92-.627-1.71-1.525-1.916zM2.98 19.94l-.898-3.898 4.219-1.81 2.393 2.928c4.245-1.995 6.47-4.212 8.464-8.467L14.232 6.3l1.809-4.22 3.897.898c-.043 9.352-7.61 16.92-16.958 16.963z",
    fill: "#192038"
  }))));
}

export default SvgPhoneLinear;